import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=3a4972ce&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4972ce')) {
      api.createRecord('3a4972ce', component.options)
    } else {
      api.reload('3a4972ce', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=3a4972ce&", function () {
      api.rerender('3a4972ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2c2yJ42po6XX0/JS/comp/ImgFallback.vue"
export default component.exports